import http from 'plugins/axios';
// const financialname = '/financialSystem'
const financialname = ''
export default {
  getList(data) {
    return http.get({
      url: '/admin/psi/list',
      data
    });
  },
  sendBonus(data) {
    return http.post({
      url: '/admin/psi/distribute',
      data,
      dataType: 'form'
    });
  },
  getAllSupportCoin() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  },

  getPartInCount(data) {
    return http.get({
      url: '/admin/psi/count',
      data
    });
  }
  //分红查询
  // getList(data) {
  //   return http.get({
  //     url: financialname+'/financialmanage/psi/list',
  //     data
  //   });
  // },
  // sendBonus(data) {
  //   return http.post({
  //     url: financialname+'/financialmanage/psi/distribute',
  //     data,
  //     dataType: 'form'
  //   });
  // },
  // getAllSupportCoin() {
  //   return http.get({
  //     url: '/admin/coin/allDisplay'
  //   });
  // },

  // getPartInCount(data) {
  //   return http.get({
  //     url: financialname+'/financialmanage/psi/count',
  //     data
  //   });
  // }
};
